var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('span',{staticStyle:{"margin-bottom":".3rem"}},[_vm._v("云东畜牧大数据平台")]),(_vm.back)?_c('div',{staticClass:"back",on:{"click":_vm.goBack}},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/yq/back.png"),"alt":""}}),_c('span',{staticClass:"title"},[_vm._v("返回上一层")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }